export class ConditionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCondition(params) {
    return this.#http.get('/condition', { params });
  }

  async getLoanActionsCondition(params) {
    return this.#http.get('/conditionLoanActionsData', { params });
  }

  async createCondition(body) {
    return this.#http.post('/condition', body);
  }

  async getConditionByConditionId({ conditionId }) {
    return this.#http.get(`/condition/${conditionId}`);
  }

  async editCondition({ conditionId, ...body }) {
    return this.#http.put(`/condition/${conditionId}`, body);
  }

  async deleteCondition({ conditionId }) {
    return this.#http.delete(`/condition/${conditionId}`);
  }
}
